import { RichTextPreviewFormData } from './contracts';

export type RichTextPreviewProps = RichTextPreviewFormData;

export const RichTextPreview = ({ content }: RichTextPreviewFormData) => {
  return (
    <div
      style={{ width: '100%' }}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
